import { createSlice, PayloadAction, SliceCaseReducers } from "@logicsoftware/redux-toolkit";
import { combineReducers } from "redux";
import { createEntitiesSlice } from "~/Redux/Entities";
import { Space } from "~/Redux/Spaces";
import { spaceSchema } from "~/Redux/Spaces/schema";
import { SpacesData, SpacesInnerState } from "~/Redux/Spaces/types";

export const { reducer: spaceEntitiesReducer, updateEntities: updateSpaces } = createEntitiesSlice<Space>(spaceSchema, {
    initState: null,
    ignoreCleanEntities: true,
});

const spaceDataSlice = createSlice<SpacesData, SliceCaseReducers<SpacesData>>({
    name: "SPACES_SLICE",
    initialState: {
        isSpacePage: false,
        menuSpaceId: null,
    },
    reducers: {
        setIsSpaceSpecificPage: (state, { payload }: PayloadAction<boolean>) => ({
            ...state,
            isSpacePage: payload,
        }),
        setMenuSpace: (state, { payload }: PayloadAction<number>) => ({
            ...state,
            menuSpaceId: payload,
        }),
    },
});

export const { setIsSpaceSpecificPage, setMenuSpace } = spaceDataSlice.actions;

export const spacesReducer = {
    spaces: combineReducers<SpacesInnerState>({
        entities: spaceEntitiesReducer,
        spacesData: spaceDataSlice.reducer,
    }),
};
